export const deleteAccountRequest = /* GraphQL */ `
  mutation DeleteAccountRequestMutation($email: String!, $reason: String!) {
    deleteAccountRequest(email: $email, reason: $reason) {
      result
      __typename
    }
  }
`;
